import type { EventBus } from '../core/EventBus';
import type { GameEvents } from '../core/GameEvents';

/** Run feedback. Not a progression system - see the rejected items in docs/TASKS.md. */
export class Score {
  private value = 0;

  constructor(private readonly bus?: EventBus<GameEvents>) {}

  get current(): number {
    return this.value;
  }

  add(points: number): void {
    if (points === 0) return;
    this.value = Math.max(0, this.value + points);
    this.bus?.emit('scoreChanged', { score: this.value });
  }

  reset(): void {
    this.value = 0;
    this.bus?.emit('scoreChanged', { score: this.value });
  }
}
